import { useState, useEffect, useContext, useRef } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { loadingContext, unfolder, openAlert, useTranslate } from '../lib';
import { SelectNesting } from './common/Inputs/Select';
import { urlValue } from '../lib';
import '../styles/styles.css';
import '../styles/newProjectModal.scss';
import { Alerts } from './common/Alerts';

export default function EditCampaignFullModal({ isModalOpen, closeModal, campaign_id, editTexts }) {
  const [loading, setLoading] = useContext(loadingContext);
  const [alert, setAlert] = useState({ title: '', visible: false });
  const [error, setError] = useState({ name: '' });
  const [region, setRegion] = useState([]);
  const { t } = useTranslate();
  const regionRef = useRef();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    (async () => {
      await fetchRegion();
      preloadData();
    })();
  }, [isModalOpen]);

  const fetchRegion = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    try {
      const url = `${urlValue}/studio/campaign/regions`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });
      if (rest.status === 200 && rest.data) {
        setRegion(rest.data);
      }
      return rest;
    } catch (error) {
      return error;
    }
  };

  const preloadData = () => {
    if (isModalOpen?.campaing) {
      setValue('name', isModalOpen.campaing.name);
      setValue('country', isModalOpen.campaing.country);
      if (regionRef.current) {
        regionRef.current.value = isModalOpen.campaing.region_id;
      }
    }
  };

  const onSubmit = async data => {
    let ok = true;
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken;
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    const exp = /^[A-Za-z0-9-,._'¿?\s]+$/g;
    if (!exp.test(data.name)) {
      ok = false;
      setError({ ...error, name: t('errors.nameInvalid') });
    }
    if (ok) {
      const dataSend = {
        name: data.name,
        country: data.country,
        region_id: regionRef.current?.value || 1,
        id: campaign_id,
      };
      axios({
        method: 'post',
        url: `${urlValue}/studio/campaign/edit/${campaign_id}`,
        headers: {
          user: id,
          'access-token': token,
          'X-CSRF-Token': csrfToken,
        },
        withCredentials: true,
        data: dataSend,
      })
        .then(function (response) {
          closeModal();
          setLoading(false);
          window.location.href = '/campaigns';
        })
        .catch(function (error) {
          console.error('Error when editing campaign:', error);
          if (error.response) {
            console.error('Error: ' + (error.response.data?.message || error.message));
          }
          if (error.response?.status === 409) {
            openAlert('#alert-ac', () => {
              setAlert({ title: error?.response?.data?.message, visible: true, error: true });
            }, 5000, () => {
              setAlert({ ...alert, visible: false });
            });
          } else {
            openAlert('#alert-ac', () => {
              setAlert({ title: t('alerts.campaignNotSaved'), visible: true, error: true });
            }, 4000, () => {
              setAlert({ ...alert, visible: false });
            });
          }
          setLoading(false);
        });
    }
  };

  return (
    <div className="newProject-modal newCampaing-modal">
      <h1>{editTexts?.title || t('menu.editCampaign')}</h1>
      <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
        <div className="inputs" id="name">
          <div className="input tooltip">
            <span>{t('common.name')}:</span>
            <input placeholder={t('menu.newCampaignName')} className='input-data' id='namecp-tp' {...register('name', { required: true })} type="text" />
          </div>
          <SelectNesting
            ref={regionRef}
            id="region"
            boxInfo={true}
            tooltipText={t('menu.regionForCampaign')}
            title="Region:"
            containerClass="mr-1"
            style={{ minWidth: 150 }}
          >
            {region?.map((item, index) => (
              <option key={`region ${index + 1}:`} value={item.id}>{item.name}</option>
            ))}
          </SelectNesting>
          <div className="input tooltip">
            <span>{t('common.country')}:</span>
            <input placeholder={t('menu.countryName')} className='input-data' id='country' {...register('country', { required: true })} type="text" />
          </div>
        </div>
        <div className="footer">
          <div className='cont-buttons'>
            {errors.name?.type === 'required' ? (
              <span style={{ color: 'red' }}>{t('menu.fieldsRequired')}</span>
            ) : (
              <span> </span>
            )}
            <span className='errors-msg'>{error.name}</span>
          </div>
          <div className='cont-buttons' style={{ marginTop: 25 }}>
            <div className="buttons">
              <button className="cancel btn-bottom btn-bottom-cancel" type="button" onClick={() => closeModal()}>
                {t('common.cancel')}
              </button>
              <button className="create btn-bottom btn-bottom-create" type="submit">
                {editTexts?.button || t('common.edit')}
              </button>
            </div>
          </div>
        </div>
      </form>
      {alert.visible && <Alerts id="alert-ac" title={alert.title} error={alert.error} />}
    </div>
  );
}
